export const timeZoneFormat = (paramDate:string, hourOffset = '03:00') =>{
    if(paramDate){
        const currentTimeZone = localStorage.getItem('timezone') ?? Intl.DateTimeFormat().resolvedOptions().timeZone
        const isoDate = paramDate
            .replace(' ', 'T')
            .replace(/(\.\d{3})\d+/, '$1') + '-' + hourOffset; // Normalizo fecha a UTC 0
        const date = new Date(isoDate);
        const formatted = new Intl.DateTimeFormat('es-AR', {
            timeZone:currentTimeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, 
            }).format(date)
            .replace(/\//g, '-')
        return formatted
    }
    return paramDate
}